<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="900"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="bulkFinalDisposalReportValidator">
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>最終処分終了報告（一括登録）</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="manifest"
          class="mt-3"
        >
          <final-disposal-report-form
            :manifest="manifest"
            :manifest-final-disposals="manifest.manifest_final_disposals"
            :final-disposal-sites="finalDisposalSites"
            @addButtonCallback="addFinalDisposals"
            @removeButtonCallback="removeFinalDisposal"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>

import { mapActions } from 'vuex'
import FinalDisposalReportForm from './forms/_FinalDisposalReportForm'

export default {
  name: 'BulkFinalDisposalReportDialog',
  components: {
    FinalDisposalReportForm,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      manifest: null,
      finalDisposalSites: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.manifest = null
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestFinalDisposalReport', {
      fetchNew: 'new',
      bulkRegister: 'create',
    }),
    ...mapActions('DriverOrderFinalDisposalReport', {
      fetchNewByOrder: 'new',
      bulkRegisterByOrder: 'create',
    }),
    ...mapActions('DriverMasterSearchFinalDisposalSite', {
      fetchFinalDisposalSites: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let self = this
      this.$refs.bulkFinalDisposalReportValidator.validate().then((result) => {
        if (result) {
          // 選択された複数マニフェストを同じ内容で更新
          let params = this._buildParams()
          if (this.type === "Managements") {
            self.bulkRegister({params: params}).then(() => {
              self.$emit('registerEvent')
            })
          } else {
            self.bulkRegisterByOrder({params: params}).then(() => {
              self.$emit('registerEvent')
            })
          }
        }
      })
    },
    setVariable () {
      this.fetchFinalDisposalSites().then((content) => {
        this.finalDisposalSites = content.final_disposal_sites
      })

      if (this.type === "Managements") {
        this.fetchNew().then((content) => {
          this.manifest = content
          this.addFinalDisposals()
        })
      } else {
        this.fetchNewByOrder().then((content) => {
          this.manifest = content
          this.addFinalDisposals()
        })
      }
    },
    /**
     * 最終処分終了報告 追加ボタンコールバック
     */
    addFinalDisposals () {
      let time = new Date().getTime()
      let b = Math.floor( time / 1000 )
      this.manifest.manifest_final_disposals.push({
        id: null,
        manifest_id: null,
        key: b,
        final_disposal_date: null,
        final_disposal_site_id: null,
        remarks: null,
        _destroy: false,
      })
    },
    /**
     * 最終処分終了報告 削除ボタンコールバック
     */
    removeFinalDisposal (manifest_id, item) {
      let finalDisposal = this.manifest.manifest_final_disposals.find(v => v.key === item.key)
      if (finalDisposal) {
        finalDisposal.final_disposal_date = null
        finalDisposal.final_disposal_site_id = null
        finalDisposal._destroy = true
      }
    },
    /**
     *
     * @private
     */
    _buildParams () {
      const params = []
      for (let manifest_final_disposal of this.manifest.manifest_final_disposals) {
        if (!manifest_final_disposal._destroy) {
          let final_params = {
            final_disposal_date: manifest_final_disposal.final_disposal_date,
            final_disposal_siteable_id: manifest_final_disposal.final_disposal_site_id,
            final_disposal_siteable_type: 'FinalDisposalSite',
          }
          params.push(final_params)
        }
      }
      return {
        manifest_final_disposals_attributes: params,
        manifest_ids: this.manifestIds,
        order_ids: this.orderIds,
        type: this.type,
      }
    },

  }
}
</script>
